import { Filters } from 'components';
import { useSelector } from 'react-redux';

const CustomFilters = ({ type, setType, sports, setSports }) => {
  const favoriteSports = useSelector((state) => state.user.favoriteSports),
    { isMobile } = useSelector((state) => state.appState);

  const subOptions = favoriteSports.map((x) => ({
    value: x.sport,
    translatedValue: `sports.${x.sport}`
  }));

  const options = [
    { value: 'athlete', translatedValue: 'common.athletes' },
    { value: 'team', translatedValue: 'common.teams' },
    { value: 'fan', translatedValue: 'common.fans' }
  ];

  function handleTypeSelect(type) {
    setType(type);
  }

  function handleSportSelect(sport) {
    if (sports.includes(sport)) {
      return setSports(sports.filter((x) => x !== sport));
    }

    setSports([...sports, sport]);
  }

  function handleClear() {
    handleTypeSelect('');
    setSports([]);
  }

  return (
    <Filters
      options={options}
      onChange={(e) => handleTypeSelect(e?.value)}
      onSubChange={(e) => handleSportSelect(e?.value)}
    />
  );
};

export default CustomFilters;
